import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { PiSeatFill } from "react-icons/pi";
import { doc, updateDoc, getDocs, collection } from "firebase/firestore";
import { db } from "../../firebase";

function Vehicles() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingVehicle, setEditingVehicle] = useState(null);

  const [vehicleNameOptions, setVehicleNameOptions] = useState([]);

  const vehicleImages = [
    "https://iiqleqeqhnesxzxpdpmc.supabase.co/storage/v1/object/public/cars/swiftcar.webp",
    "https://iiqleqeqhnesxzxpdpmc.supabase.co/storage/v1/object/public/cars/altocar.webp",
    "https://iiqleqeqhnesxzxpdpmc.supabase.co/storage/v1/object/public/cars/innova.webp",
    "https://iiqleqeqhnesxzxpdpmc.supabase.co/storage/v1/object/public/cars/fortuner.webp",
    "https://iiqleqeqhnesxzxpdpmc.supabase.co/storage/v1/object/public/cars/ertigacar.webp",
  ];

  const [formData, setFormData] = useState({
    name: "",
    fuel: "",
    seat: "",
    base_price: "",
    daily_price: "",
    km_price: "",
    type: "",
    img_url: "",
    vehicle_name: "",
  });

  // ✅ Fetch Vehicles (No Realtime)
  const fetchVehicles = async () => {
    setLoading(true);

    // 1️⃣ Fetch vehicles from Supabase
    const { data: supabaseVehicles, error } = await supabase
      .from("Vehicles")
      .select("*")
      .order("id", { ascending: true });

    if (error) {
      console.error(error);
      setLoading(false);
      return;
    }

    // 2️⃣ Fetch status from Firestore
    const statusSnapshot = await getDocs(collection(db, "Vehicles"));

    let statusMap = {};
    statusSnapshot.forEach((docSnap) => {
      statusMap[docSnap.id] = docSnap.data().status;
    });

    // 3️⃣ Merge status into Supabase vehicles
    const mergedVehicles = supabaseVehicles.map((vehicle) => ({
      ...vehicle,
      status: statusMap[vehicle.id] ?? 0, // default 0 if not found
    }));

    setVehicles(mergedVehicles);
    setLoading(false);
  };


  useEffect(() => {
  const fetchVehicleNames = async () => {
    const { data, error } = await supabase
      .from("Vehicles")
      .select("id, name")
      .order("name", { ascending: true });

    if (!error && data) {
      // Remove duplicate names
      const uniqueNames = [
        ...new Map(data.map(item => [item.name, item])).values()
      ];

      setVehicleNameOptions(uniqueNames);
    }
  };

  fetchVehicleNames();
}, []);

  const handleToggleStatus = async (vehicle) => {
    try {
      const newStatus = vehicle.status === 1 ? 0 : 1;

      await updateDoc(doc(db, "Vehicles", vehicle.id.toString()), {
        status: newStatus,
      });

      // Update UI instantly
      setVehicles((prev) =>
        prev.map((v) =>
          v.id === vehicle.id ? { ...v, status: newStatus } : v,
        ),
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  useEffect(() => {
    fetchVehicles();
  }, []);

  // ✅ Save or Update
const handleSaveVehicle = async () => {
  const payload = {
    name: formData.name,
    fuel: formData.fuel,
    seat: formData.seat,
    daily_price: formData.daily_price,
    km_price: formData.km_price,
    type: formData.type,
    img_url: formData.img_url,
  };

  if (editingVehicle) {
    const { error } = await supabase
      .from("Vehicles")
      .update(payload)
      .eq("id", editingVehicle.id);

    if (error) console.error("Update error:", error);
  } else {
    const { error } = await supabase
      .from("Vehicles")
      .insert([payload]);

    if (error) console.error("Insert error:", error);
  }

  setShowModal(false);
  setEditingVehicle(null);
  fetchVehicles();
};

const openEdit = (vehicle) => {
  setEditingVehicle(vehicle);

  setFormData({
    name: vehicle.name || "",
    fuel: vehicle.fuel || "",
    seat: vehicle.seat || "",
    daily_price: vehicle.daily_price || "",
    km_price: vehicle.km_price || "",
    type: vehicle.type || "",
    img_url: vehicle.img_url || "",
  });

  setShowModal(true);
};

  const openAdd = () => {
    setEditingVehicle(null);
    setFormData({
      name: "",
      fuel: "",
      seat: "",
      base_price: "",
      daily_price: "",
      km_price: "",
      type: "",
      img_url: "",
      vehicle_name: "",
    });
    setShowModal(true);
  };

  return (
    <div className="container" style={{ padding: "20px", marginTop: "60px" }}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="heading-title mt-4">Vehicles</h5>
        <button className="btn btn-dark btn-sm" onClick={openAdd}>
          + Add Vehicle
        </button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="row">
          {vehicles.map((v) => {
      
            return (
              <div className="col-md-4 mb-4" key={v.id}>
                <div className="card shadow-sm p-3 h-100">
                  <div className="d-flex align-items-center gap-2">
                    <img
                      src={v.img_url}
                      alt="vehicle"
                      style={{ width: "90px" }}
                    />

                    <div>
                      <h6 className="mb-1">{v.name}</h6>

                      <div className="d-flex gap-3">
                        <p className="mb-0">
                          <strong>Type:</strong> {v.type}
                        </p>
                        <p className="mb-0">
                          <BsFillFuelPumpFill className="icon text-danger" />{" "}
                          {v.fuel}
                        </p>
                        <p className="mb-0">
                          <PiSeatFill className="icon" /> {v.seat} Seats
                        </p>
                      </div>

                      <div className="d-flex gap-3">
                        <p className="mb-0">
                          Daily: <strong>₹{v.daily_price}</strong>
                        </p>
                        <p className="mb-0">
                          Km: <strong>₹{v.km_price}</strong>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex gap-2 mt-1">
                    <div className="d-flex gap-2 mt-2">
                      <button
                        className="btn btn-dark"
                        onClick={() => openEdit(v)}
                      >
                        Edit
                      </button>

                      <button
                        className={`btn ${
                          v.status === 1 ? "btn-success" : "btn-secondary"
                        }`}
                        onClick={() => handleToggleStatus(v)}
                      >
                        {v.status === 1 ? "Active" : "Inactive"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div
          className="bottom-modal-overlay"
          onClick={() => setShowModal(false)}
        >
          <div className="bottom-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h5>{editingVehicle ? "Edit" : "Add"} Vehicle</h5>
              <button
                className="btn-close"
                onClick={() => setShowModal(false)}
              />
            </div>

            {/* ✅ Manual Fields */}
            <select
              className="modal-input"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
            >
              <option value="">Select Vehicle</option>
              {vehicleNameOptions.map((v) => (
                <option key={v.id} value={v.name}>
                  {v.name}
                </option>
              ))}
            </select>

           

            <div className="d-flex gap-2">
             
              <div>
                <label className="form-label mb-0 mt-2">Vehicle Type</label>
                {/* ✅ Type Dropdown */}
                <select
                  className="modal-input mt-0"
                  value={formData.type}
                  onChange={(e) =>
                    setFormData({ ...formData, type: e.target.value })
                  }
                >
                  <option value="">Select Type</option>
                  <option value="sedan">Sedan</option>
                  <option value="premium">Premium</option>
                </select>
              </div>
            </div>

            <div className="d-flex gap-2">
              <div>
                {/* ✅ Seat Capacity */}
                <label className="form-label mb-0 mt-2">Seat Capacity</label>
                <input
                  type="number"
                  placeholder="Seats"
                  className="modal-input mt-0"
                  value={formData.seat}
                  onChange={(e) =>
                    setFormData({ ...formData, seat: e.target.value })
                  }
                />
              </div>
              <div>
                {/* ✅ Fuel Dropdown */}
                <label className="form-label mb-0 mt-2">Fuel type</label>
                <select
                  className="modal-input mt-0"
                  value={formData.fuel}
                  onChange={(e) =>
                    setFormData({ ...formData, fuel: e.target.value })
                  }
                >
                  <option value="">Select Fuel</option>
                  <option value="Petrol">Petrol</option>
                  <option value="Diesel">Diesel</option>
                  <option value="CNG">CNG</option>
                </select>
              </div>
            </div>

            <div className="d-flex gap-2">
              <div>
                <label className="form-label mb-0 mt-2">Per Km Rate</label>
                <input
                  type="number"
                  placeholder="Per KM Price"
                  className="modal-input mt-0"
                  value={formData.km_price}
                  onChange={(e) =>
                    setFormData({ ...formData, km_price: e.target.value })
                  }
                />
              </div>
              <div>
                {/* ✅ Fuel Dropdown */}
                <label className="form-label mb-0 mt-2">Daily Rate</label>
                <input
                  type="number"
                  placeholder="Daily Price"
                  className="modal-input mt-0"
                  value={formData.daily_price}
                  onChange={(e) =>
                    setFormData({ ...formData, daily_price: e.target.value })
                  }
                />
              </div>
            </div>

            <h6 className="mt-3">Select Car</h6>

            <div className="d-flex gap-2 flex-wrap mb-3">
              {vehicleImages.map((img, i) => (
                <div
                  key={i}
                  onClick={() => setFormData({ ...formData, img_url: img })}
                  style={{
                    border:
                      formData.img_url === img
                        ? "2px solid green"
                        : "1px solid #ddd",
                    borderRadius: "10px",
                    cursor: "pointer",
                    padding: "3px",
                  }}
                >
                  <img
                    src={img}
                    width={70}
                    style={{ borderRadius: "8px" }}
                    alt="option"
                  />
                </div>
              ))}
            </div>

            <button
              className="btn btn-dark py-2 w-100"
              onClick={handleSaveVehicle}
            >
              Save Vehicle
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Vehicles;
